import { useApiMutation } from "./use-api-mutation";

export function useForgotPassword() {
	return useApiMutation("post", "/auth/forgot-password", {
		notify: false,
		onMutate: () => {
			// TODO: Migrate x-auth-request header logic to new client
			// Add x-auth-request header to prevent token refresh interceptor from acting on this request
		},
		onSettled: () => {
			// TODO: Migrate x-auth-request header cleanup to new client
		},
	});
}
